export default __webpack_public_path__ + "static/media/o2.ab93672a.webp";